import {AuthGuard} from '../../shared/guards/AuthGuard';
import {ProposalListPresentation} from './components';
import {Sidebar} from '../../shared/components';

export const ProposalListPage = (): JSX.Element => {
    return (
        <AuthGuard>
            <Sidebar>
                <ProposalListPresentation/>
            </Sidebar>
        </AuthGuard>
    )
};